import { CSSProperties, Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  cardItems: {
    padding: "12px 10px",
    borderRadius: 0,
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
    cursor: "pointer",

    "&:hover": {
      backgroundColor: theme.palette.gray.light,
    },
    "&:hover $enterLabel": {
      visibility: "visible",
    },
  },
  cardItemsPresentationMode: {
    backgroundColor: "#2C2F3C", // to add to palette
    border: "1px solid #333544",
    "&:hover": {
      backgroundColor: "#313440",
    },
  },
  eventImage: {
    position: "relative",
    border: "1px solid #EAEAEA",
    borderRadius: "5px",
    width: "50px",
    minWidth: "50px",
    height: "36.67px",
    marginRight: "10px",
    objectFit: "cover",
  },
  eventImagePresentationMode: {
    border: "1px solid #333544",
  },
  itemTextPresentationMode: {
    color: theme.palette.white,
    opacity: 0.7,
  },
  enterLabel: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.events.blueSecondary,
    display: "flex",
    marginLeft: "auto",
    alignItems: "center",
    visibility: "hidden",
  } as CSSProperties,
  lockIcon: {
    display: "flex",
    marginLeft: "auto",
    alignItems: "center",
    "& path": {
      fill: theme.palette.events.blueSecondary,
    },
  },
  isPrivateEvent: {
    marginLeft: "10px",
  },
}));
